exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_AttachmentsContainer_DYotkgbLLaJtsazrRqxpR {\n  margin: 45px 40px 20px 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.IA_AttachmentsAttachment_3Dxi4KPcNEsb4qmk04YnpQ {\n  display: flex;\n  align-items: center;\n}\n\n.IA_AttachmentsLink_3-xgcYFbR9cZ4cDR81vrXA {\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_AttachmentsContainer": "IA_AttachmentsContainer_DYotkgbLLaJtsazrRqxpR",
	"IA_AttachmentsAttachment": "IA_AttachmentsAttachment_3Dxi4KPcNEsb4qmk04YnpQ",
	"IA_AttachmentsLink": "IA_AttachmentsLink_3-xgcYFbR9cZ4cDR81vrXA"
};